import classNames from 'classnames';
import Bar from '../../components/Bar/Bar';
import Divider from '../../components/Divider/Divider';
import Justify from '../../types/enum/Justify';
import Size from '../../types/enum/Size';
import IDialogHeaderProps from './DialogHeaderProps';

const DialogHeader = ({ justify, divider, inset, size, className, children }: IDialogHeaderProps) => {
  const classes = classNames(
    {
      'dialog-header': true,
      [`px-${inset}`]: inset && inset > -1,
    },
    className
  );

  return (
    <>
      <Bar size={size} justify={justify} className={classes}>
        {children}
      </Bar>
      {divider && <Divider />}
    </>
  );
};

DialogHeader.defaultProps = {
  justify: Justify.FLEX_START,
  divider: false,
  inset: 8,
  size: Size.LARGE,
};

export default DialogHeader;
